module.exports = __webpack_public_path__ + "static/media/nt-1.90d5da5a.png";